module.exports = __webpack_public_path__ + "static/img/group-6.ca4d4df2.png";